import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  addReplyToQuestionApi,
  addThreadedReplyToQuestionApi,
  deleteReplyToQuestionApi,
  deleteThreadedReplyToQuestionApi,
  editThreadedReplyToQuestionApi,
  getAllQuestions,
  updateStatus
} from "../../api/faqApi";

export const updateQuestionStatus = createAsyncThunk(
  "questions/updateQuestionStatus",
  async ({ status, questionId }, thunkAPI) => {
    try {
      const response = await updateStatus(status, questionId);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const addReplyToQuestion = createAsyncThunk(
  "questions/addReplyToQuestion",
  async ({ questionId, reply }, thunkAPI) => {
    try {
      const response = await addReplyToQuestionApi({ questionId, reply });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const addThreadedReplyToQuestion = createAsyncThunk(
  "questions/addThreadedReplyToQuestion",
  async ({ questionId, message }, thunkAPI) => {
    try {
      const response = await addThreadedReplyToQuestionApi({
        questionId,
        message
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteReplyToQuestion = createAsyncThunk(
  "questions/deleteReplyToQuestion",
  async ({ questionId }, thunkAPI) => {
    try {
      const response = await deleteReplyToQuestionApi({ questionId });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const deleteThreadedReplyToQuestion = createAsyncThunk(
  "questions/deleteThreadedReplyToQuestion",
  async ({ questionId, replyId }, thunkAPI) => {
    try {
      const response = await deleteThreadedReplyToQuestionApi({
        questionId,
        replyId
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const editThreadedReplyToQuestion = createAsyncThunk(
  "questions/editThreadedReplyToQuestion",
  async ({ questionId, replyId, message }, thunkAPI) => {
    try {
      const response = await editThreadedReplyToQuestionApi({
        questionId,
        replyId,
        message
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAllQuestionsData = createAsyncThunk(
  "questions/getAllQuestions",
  async ({ page = 0, limit = 10 }, thunkAPI) => {
    try {
      const response = await getAllQuestions(page, limit);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Initial state
const initialState = {
  questions: [], // holds the meals data
  loading: false, // loading state for getAllMeals
  error: null, // error state
  total: 0,
  page: 0,
  limit: 10
};

const questionsSlice = createSlice({
  name: "questions",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllQuestionsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllQuestionsData.fulfilled, (state, action) => {
        state.loading = false;
        state.questions = action.payload.questions; // assuming response has meals data
        state.total = action.payload.totalQuestions; // total pages
      })
      .addCase(getAllQuestionsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setPage, setLimit } = questionsSlice.actions;

export default questionsSlice.reducer;
